import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button as ButtonComponent } from "@sunwing/shared-components";
import { Link } from "../Link";
import { Icon } from "../Icon";
import styles from "./Button.module.scss";

const Button = ({
	children,
	type,
	label,
	to,
	target,
	onClick,
	icon,
	iconPlacement,
	theme,
	size,
	outline,
	disabled,
	full,
	noStyle,
	defaultStyle,
	className,
	linkComponentProps,
}) => {
	const commonStyle = cx({
		[styles[`btn--${size}`]]: size,
		[styles["btn--empty"]]: !label,
		[styles["btn--disabled"]]: disabled,
		[styles["btn--has-label"]]: label,
		[styles[`btn--icon-${iconPlacement}`]]: (icon && iconPlacement) || iconPlacement === "right",
		[className]: className,
	});

	const classes = cx({
		[styles.btn]: defaultStyle,
		[commonStyle]: commonStyle,
		[styles[`btn--${theme}`]]: theme,
		[styles["btn--outline"]]: outline,
		[styles["btn--full"]]: full,
		[className]: className,
	});

	const noStyleClasses = cx({
		[commonStyle]: commonStyle,
	});

	return (
		<ButtonComponent
			type={type}
			label={children || label}
			to={to}
			target={target}
			onClick={onClick}
			icon={icon && <Icon name={icon} />}
			iconPlacement={iconPlacement}
			theme={false}
			size={size}
			outline={outline}
			disabled={disabled}
			full={full}
			asText={false}
			noStyle={noStyle}
			className={noStyle ? noStyleClasses : classes}
			LinkComponent={Link}
			linkComponentProps={linkComponentProps}
		/>
	);
};

Button.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	type: PropTypes.oneOf(["button", "submit", "reset"]),
	label: PropTypes.string,
	to: PropTypes.string,
	target: PropTypes.string,
	onClick: PropTypes.func,
	icon: PropTypes.string,
	iconPlacement: PropTypes.oneOf(["right", "left"]),
	theme: PropTypes.oneOf(["primary", "wedding", "booking-path"]),
	size: PropTypes.oneOf(["sm", "md", "lg", "auto"]),
	outline: PropTypes.bool,
	disabled: PropTypes.bool,
	full: PropTypes.bool,
	noStyle: PropTypes.bool,
	defaultStyle: PropTypes.bool,
	className: PropTypes.string,
	linkComponentProps: PropTypes.object,
};
Button.defaultProps = {
	children: undefined,
	type: "button",
	label: undefined,
	to: undefined,
	target: "_self",
	onClick: undefined,
	icon: undefined,
	iconPlacement: undefined,
	theme: "primary",
	size: "md",
	outline: false,
	disabled: false,
	full: false,
	noStyle: false,
	defaultStyle: true,
	className: undefined,
	linkComponentProps: {},
};

export default Button;
export { Button };
